import { FC } from 'react';
import styles from '../NotificationDrawer.module.scss';

interface NotificationFooterProps {
  isOrderRow: boolean;
  dcn: string;
  formattedDate: string;
  formattedTime: string;
}

export const NotificationFooterContent: FC<NotificationFooterProps> = ({
  isOrderRow = false,
  dcn,
  formattedDate,
  formattedTime,
}) => {
  return (
    <div
      className={`${styles['notification-footer']}`}
      data-testid="footer-notification"
    >
      <div
        className={
          isOrderRow
            ? `${styles['footer_order_change']}`
            : `${styles['notification_container']}`
        }
      >
        {dcn ? <div className={`${styles['dcn_container']}`}>{dcn}</div> : null}
        <div className={`${styles['date_container']}`}>
          {formattedDate} &bull; {formattedTime}
        </div>
      </div>
    </div>
  );
};
